import { Link, useParams, useNavigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import Preloading from "../../../components/basics/Preloading";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";
import Paginations from "../../../components/paginaton/Paginations";

const BaseInfoServices = () => {
  const { restaurantId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [measurements, setMeasurements] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [natureTypes, setNatureType] = useState([]);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [productCategories, setProductCategories] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [filterModel, setFilterModel] = useState({
    restaurantId: restaurantId,
    title: "",
    natureType: 0,
    productType: 5,
    code: "",
    size: 10,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    natureType: 5,
    productType: 5,
    unitMeasurementId: 0,
    secondUnitMeasurementId: 0,
    description: "",
    categoryId: 0,
    branchId: null,
    restaurantId: restaurantId,
    takroSyncCode: "",
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    const resp = await apiMethod.getRestaurantServices(
      filterModel.restaurantId,
      filterModel.productType,
      filterModel.natureType,
      filterModel.title,
      filterModel.code,
      filterModel.size,
      part
    );
    if (!methods.showApiErrors(resp)) return false;
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    filterModel.part = part;
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
  };

  const getBaseInfo = async () => {
    const resp1 = await apiMethod.getRestaurantUnitMeasurements(
      filterModel.restaurantId,
      "",
      100,
      1
    );
    if (methods.showApiErrors(resp1)) setMeasurements(resp1.data);

    const resp2 = await apiMethod.getProductTypes();
    if (methods.showApiErrors(resp2)) setProductTypes(resp2.data);

    const resp3 = await apiMethod.getRestaurantProductCategories(
      filterModel.restaurantId,
      "",
      100,
      1
    );
    if (methods.showApiErrors(resp3)) setProductCategories(resp3.data);

    const resp4 = await apiMethod.getNatureType();
    if (methods.showApiErrors(resp4)) setNatureType(resp4.data);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getBaseInfo();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [restaurantId]);

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (formModel.restaurantId === 0) {
      errors.push(".ششناسه شعبه باید مقدار داشته باشد");
    }
    // if (formModel.productType === 0) {
    //   errors.push(".نوع کالا باید مقدار داشته باشد");
    // }
    if (formModel.categoryId === 0) {
      errors.push(".طبقه کالا باید مقدار داشته باشد");
    }
    if (formModel.unitMeasurementId === 0) {
      errors.push(".واحد سنجش باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.nature = "";
    formModel.productType = 5;
    formModel.unitMeasurementId = 0;
    formModel.natureType = 5;
    formModel.secondUnitMeasurementId = 0;
    formModel.takroSyncCode = "";
    formModel.description = "";
    formModel.categoryId = 0;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.restaurantId = restaurantId;
    filterModel.title = "";
    filterModel.code = "";
    filterModel.natureType = 0;
    filterModel.size = 10;
    filterModel.productType = 5;
    filterModel.part = 1;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getProductInfo(id);
    if (!methods.showApiErrors(resp)) return false;
    formModel.id = resp.data.id;
    formModel.title = resp.data.title;
    formModel.natureType = resp.data.natureType;
    formModel.productType = resp.data.productType;
    formModel.unitMeasurementId = resp.data.unitMeasurementId;
    formModel.secondUnitMeasurementId = resp.data.secondUnitMeasurementId;
    formModel.takroSyncCode = resp.data.takroSyncCode;
    formModel.description = resp.data.description;
    formModel.categoryId = resp.data.categoryId;
    formModel.restaurantId = resp.data.restaurantId;
    setFormModel({ ...formModel });
    setLoading(false);
  };

  const createNewItem = async () => {
    if (!validForm()) return false;
    setLoading(true);
    const resp = await apiMethod.createRestaurantProduct(formModel);
    if (!methods.showApiErrors(resp)) return false;
    await getGridData();
    resetForm();
    setLoading(false);
    return true;
  };

  const selectَItemToDelete = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeProduct(itemToDelete.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const searchItem = async () => {
    setLoading(true);
    filterModel.title = document.getElementById("searchInput").value;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const copyItem = (item) => {
    console.log(item);
    formModel.title = item.title;
    formModel.description = item.description;
    formModel.categoryId = item.categoryId;
    formModel.takroSyncCode = item.takroSyncCode;
    formModel.unitMeasurementId = item.unitMeasurementId;
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderProduct = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/baseinfo/restaurant/${restaurantId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/baseinfo/restaurant/${restaurantId}`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                خدمت
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                خدمت
                <a
                  href={`/sale/${restaurantId}/softwareGuide/#section2`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3" id="add_item">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <button className="btn-action" onClick={resetForm}>
                  <img src={newLogo} alt="Image" />
                  <span style={{ fontSize: "12px" }}>جدید</span>
                </button>
              </div>
              <div className="mb-4">
                <span className="fw-bold fs-5">افزودن / ویرایش خدمت</span>
              </div>
              <div className="row g-3">
                <div className="col-12 col-lg-3">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="title"
                    name="title"
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({ ...formModel, title: e.target.value });
                    }}
                    placeholder="عنوان را بنویسید..."
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <label
                    htmlFor="category"
                    className="form-label required-label"
                  >
                    طبقه کالا
                  </label>
                  <select
                    id="category"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.categoryId}
                    onChange={(e) => {
                      formModel.categoryId = parseInt(e.target.value);
                      setFormModel({
                        ...formModel,
                        categoryId: formModel.categoryId,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {productCategories.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 col-lg-3">
                  <label htmlFor="title" className="form-label">
                    کد رابط کالای حسابداری
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="title"
                    name="title"
                    value={formModel.takroSyncCode}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        takroSyncCode: e.target.value,
                      });
                    }}
                    placeholder="کد رابط حسابداری را بنویسید..."
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <label
                    htmlFor="unitMeasurement"
                    className="form-label required-label"
                  >
                    واحد سنجش اصلی
                  </label>
                  <select
                    id="unitMeasurement"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.unitMeasurementId}
                    onChange={(e) => {
                      formModel.unitMeasurementId = parseInt(e.target.value);
                      setFormModel({
                        ...formModel,
                        unitMeasurementId: formModel.unitMeasurementId,
                      });
                    }}
                  >
                    <option value={0}>انتخاب کنید</option>
                    {measurements.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control input-textare"
                    id="description"
                    name="description"
                    rows={3}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                    placeholder="توضیحات را بنویسید..."
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2 mt-4">
                <button
                  type="button"
                  className="btn custome-btn btn-link-purple "
                  onClick={() => {
                    resetForm();
                  }}
                >
                  انصراف
                </button>
                <button
                  onClick={() => {
                    createNewItem();
                  }}
                  type="button"
                  className="btn custome-btn btn-purple"
                >
                  ثبت وذخیره
                </button>
              </div>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-12 col-md-3 col-lg-3">
                  <label htmlFor="funit" className="form-label">
                    عنوان
                  </label>
                  <div className="hstack">
                    <input
                      id="searchInput"
                      className="form-control input-form"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={filterModel.title}
                      onChange={(e) => {
                        setFilterModel({
                          ...filterModel,
                          title: e.target.value,
                          part: 1,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3 col-lg-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">خدمت</span>
              <div className="table-responsive baseinfoTable">
                {productCategories.length === 0 && (
                  <div className="my-5">
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button
                        className="btn btn-outline-purple"
                        onClick={() => {
                          navigate(
                            `/baseinfo/restaurant/${restaurantId}/productcategory`
                          );
                        }}
                      >
                        افزودن کالا
                      </button>
                    </div>
                  </div>
                )}
                {measurements.length === 0 && (
                  <div className="my-5">
                    <div>
                      <span>اطلاعات مربوط به این بخش باید تکمیل شود. </span>
                      <button
                        className="btn btn-outline-purple"
                        onClick={() => {
                          navigate(
                            `/baseinfo/restaurant/${restaurantId}/unitmeasurements`
                          );
                        }}
                      >
                        افزودن واحد سنجش
                      </button>
                    </div>
                  </div>
                )}
                {gridData.length !== 0 && (
                  <table className="table table-md table-custom">
                    <thead className="align-middle">
                      <tr>
                        <th scope="col vertical-center" width="20px">
                          ردیف
                        </th>
                        <th scope="col vertical-center">عنوان</th>
                        <th scope="col vertical-center">کد کالا</th>
                        <th scope="col vertical-center">واحد اصلی</th>
                        <th scope="col vertical-center">
                          کد رابط کالای حسابداری
                        </th>
                        <th scope="col vertical-center">کد شعبه</th>
                        <th scope="col vertical-center">توضیحات</th>
                        <th scope="col vertical-center" width="100px">
                          عملیات
                        </th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {gridData.map((item, index) => (
                        <tr key={item.id}>
                          <th scope="row">
                            {(filterModel.part - 1) * filterModel.size + index + 1}
                            </th>
                          <td>{item.title}</td>
                          <td>{item.code}</td>
                          <td>{item.unitMeasurementTitle}</td>
                          <td>{item.takroSyncCode}</td>
                          <td>{item.restaurantId}</td>
                          <td>
                            {item.description.length > 10
                              ? item.description.slice(0, 30) + "..."
                              : item.description}
                          </td>
                          <td className="d-flex align-items-center justify-content-center gap-2">
                            <button
                              className="button-action copy-btn"
                              onClick={() => copyItem(item)}
                            >
                              <img src={copy} alt="Copy" />
                            </button>
                            <button
                              onClick={() => editItem(item.id)}
                              className="button-action"
                              type="button"
                            >
                              <img src={EditIcon} alt="Edit" />
                            </button>
                            <button
                              onClick={() => selectَItemToDelete(item)}
                              className="button-action"
                              type="button"
                            >
                              <img src={DeleteIcon} alt="delete" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <>
      {renderProduct()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={"کالا"}
        />
      )}
    </>
  );
};

export default BaseInfoServices;
